/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativePreviewModalComponent} from './creative-preview-modal.component';

export interface CreativePreviewModalOptions {
  creative: any;
  lineItem: any;
  teamId: string;
}

@Injectable({providedIn: 'root'})
export class CreativePreviewModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: CreativePreviewModalOptions): void {
    this.angularModalService.show(CreativePreviewModalComponent, {
      class: 'modal-lg',
      initialState: options
    });
  }
}
